import { Component } from '@angular/core';
import { Mode } from '../../components/confirmation-code/mode.service';

@Component({
  selector: 'auth-login-confirmation-code',
  templateUrl: './login-confirmation-code.component.html',
  styleUrls: ['./login-confirmation-code.component.scss']
})
export class LoginConfirmationCodeComponent {

  mode: Mode = Mode.AUTH;

  constructor() { }

}


